import { owaComputedFn } from 'owa-computed-fn';
import type { AppGalleryButtonOnExecuteParameter, AppIconGalleryButtonProps } from 'owa-acui';
import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import { type MailRibbonControlId } from 'owa-ribbon-ids/lib/mailRibbonId';
import { lazyOnExecuteQuickStep } from 'owa-mail-quick-step-actions';
import { lazyMountAndShowFullOptions } from 'owa-options-view';
import { getRibbonMailboxInfo } from 'owa-mail-ribbon-utils/lib/getRibbonMailboxInfo';
import type { ClientItemId } from 'owa-client-ids';
import type { MailboxInfo } from 'owa-client-types';
import getProjection from 'owa-popout-v2/lib/utils/getProjection';
import { lazyCreateNewQuickStep } from 'owa-quick-steps-option/lib/QuickStepsOption';
import { getSelectedTableView } from 'owa-mail-list-store';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';

function getEffectiveMailboxInfo(props: ReadOnlyRibbonControlDefProps): MailboxInfo {
    if (!props.itemId) {
        const tableView = getSelectedTableView(true /* shouldGetEffectiveTableView */);
        return getMailboxInfo(tableView);
    }
    return getRibbonMailboxInfo(props.mailboxInfo);
}

export const onExecuteQuickStep = (
    id: string,
    itemId: ClientItemId | undefined,
    mailboxInfo: MailboxInfo,
    tabId: string | undefined
): void => {
    const targetWindow = retrieveWindowForRibbon(tabId);
    lazyOnExecuteQuickStep.importAndExecute(id, itemId, mailboxInfo, targetWindow, tabId);
};

export const onManageQuickStepsClicked = (props: ReadOnlyRibbonControlDefProps): void => {
    const targetWindow = retrieveWindowForRibbon(props.projectionTabId);
    lazyMountAndShowFullOptions.importAndExecute(
        'mail',
        'quickSteps',
        undefined /*options*/,
        targetWindow /*targetWindow*/,
        getEffectiveMailboxInfo(props)
    );
};

export const onCreateNewQuickStepClicked = (props: ReadOnlyRibbonControlDefProps): void => {
    lazyCreateNewQuickStep.importAndExecute();
    const targetWindow = retrieveWindowForRibbon(props.projectionTabId);
    lazyMountAndShowFullOptions.importAndExecute(
        'mail',
        'quickSteps',
        undefined /*options*/,
        targetWindow /*targetWindow*/,
        getEffectiveMailboxInfo(props)
    );
};

export const onQuickStepGalleryButtonExecute: (
    props: ReadOnlyRibbonControlDefProps
) => ({ galleryButton }: AppGalleryButtonOnExecuteParameter<AppIconGalleryButtonProps>) => void =
    owaComputedFn(function onQuickStepGalleryButtonExecute(
        props: ReadOnlyRibbonControlDefProps
    ): ({ galleryButton }: AppGalleryButtonOnExecuteParameter<AppIconGalleryButtonProps>) => void {
        return ({
            galleryButton,
        }: AppGalleryButtonOnExecuteParameter<AppIconGalleryButtonProps>) => {
            const { id } = galleryButton;

            if (id === (550).toString()) {
                onManageQuickStepsClicked(props);
            } else {
                const targetWindow = retrieveWindowForRibbon(props.projectionTabId);
                lazyOnExecuteQuickStep.importAndExecute(
                    id,
                    props.itemId,
                    getEffectiveMailboxInfo(props),
                    targetWindow,
                    props.projectionTabId
                );
            }
        };
    });

function retrieveWindowForRibbon(tabId: string | undefined): Window {
    if (tabId) {
        const projection = getProjection(tabId);
        return projection?.window || window;
    }
    return window;
}
